import { useState, useEffect } from 'react';
import { MOBILE_BREAKPOINT } from '@/variables';

export function useIsMobile(): boolean {
    const mqString = `(max-width: ${MOBILE_BREAKPOINT - 1}px)`;
    const [isMobile, setIsMobile] = useState(
        () =>
            typeof window !== 'undefined' &&
            window.matchMedia(mqString).matches
    );

    useEffect(() => {
        if (typeof window === 'undefined') return;

        const mediaQueryList = window.matchMedia(mqString);

        const handler = (event: MediaQueryListEvent) => {
            setIsMobile(event.matches);
        };

        if (mediaQueryList.addEventListener) {
            mediaQueryList.addEventListener('change', handler);
        } else {
            mediaQueryList.addListener(handler);
        }

        return () => {
            if (mediaQueryList.removeEventListener) {
                mediaQueryList.removeEventListener('change', handler);
            } else {
                mediaQueryList.removeListener(handler);
            }
        };
    }, [mqString]);

    return isMobile;
}
